(function () {

  if (window.cartFreeGiftsLoaded) return;
  window.cartFreeGiftsLoaded = true;


  async function removeInvalidFreeGifts() {

    try {

      const invalidGiftElements = document.querySelectorAll(
        '[data-invalid-free-gift]'
      );

      /*
       * Nothing invalid found.
       * Do nothing.
       */
      if (!invalidGiftElements.length) return;


      const response = await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            'Accept': 'application/json'
          }
        }
      );


      if (!response.ok) {
        throw new Error('Unable to read cart');
      }


      const cart = await response.json();

      let giftRemoved = false;


      for (const element of invalidGiftElements) {

        const promotionHandle =
          element.dataset.promotionHandle || '';


        if (!promotionHandle) continue;


        /*
         * Find the gift that belongs
         * to this specific promotion.
         */
        const giftItem = cart.items.find(item =>
          item.properties &&
          item.properties._free_gift === 'true' &&
          item.properties._free_gift_promotion === promotionHandle
        );


        if (!giftItem) continue;


        console.log(
          'Removing invalid free gift:',
          promotionHandle,
          giftItem
        );


        const removeResponse = await fetch(
          `${window.Shopify.routes.root}cart/change.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              id: giftItem.key,
              quantity: 0
            })
          }
        );


        if (!removeResponse.ok) {
          console.error(
            'Unable to remove invalid free gift:',
            promotionHandle
          );

          continue;
        }


        giftRemoved = true;

      }


      /*
       * Only reload if a gift was
       * actually removed.
       */
      if (giftRemoved) {
        window.location.reload();
      }


    } catch (error) {

      console.error(
        'Free gift validation error:',
        error
      );

    }

  }



  /*
   * FREE GIFT CHOOSE / CHANGE
   */

  document.addEventListener(
    'click',
    async function (event) {

      const button = event.target.closest(
        '[data-free-gift-button]'
      );


      if (!button) return;


      event.preventDefault();


      const promotionContainer = button.closest(
        '[data-free-gift-promotion]'
      );


      if (!promotionContainer) {

        console.error(
          'Free gift promotion container not found'
        );

        return;

      }


      const newVariantId = Number(
        button.dataset.variantId
      );


      const promotionHandle =
        button.dataset.promotionHandle || '';


      const currentGiftVariantId = Number(
        promotionContainer.dataset.currentGiftVariant || 0
      );


      const currentGiftKey =
        promotionContainer.dataset.currentGiftKey || '';


      console.log(
        'Free gift clicked:',
        {
          newVariantId,
          promotionHandle,
          currentGiftVariantId,
          currentGiftKey
        }
      );


      if (!newVariantId) {

        console.error(
          'Free gift variant ID missing'
        );

        return;

      }


      const originalText =
        button.textContent;


      button.disabled = true;


      button.textContent =
        currentGiftVariantId
          ? 'CHANGING...'
          : 'ADDING...';


      try {

        /*
         * If customer already selected
         * another gift from this promotion,
         * remove it first.
         */

        if (
          currentGiftKey &&
          currentGiftVariantId &&
          currentGiftVariantId !== newVariantId
        ) {

          const removeResponse = await fetch(
            `${window.Shopify.routes.root}cart/change.js`,
            {
              method: 'POST',

              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },

              body: JSON.stringify({
                id: currentGiftKey,
                quantity: 0
              })
            }
          );


          if (!removeResponse.ok) {

            throw new Error(
              'Unable to remove current gift'
            );

          }

        }


        /*
         * Add selected free gift.
         */

        const addResponse = await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id: newVariantId,
                  quantity: 1,

                  properties: {
                    '_free_gift': 'true',
                    '_free_gift_promotion': promotionHandle
                  }
                }
              ]
            })
          }
        );


        const result =
          await addResponse.json();


        console.log(
          'Free gift response:',
          result
        );


        if (!addResponse.ok) {

          throw new Error(
            result.description ||
            result.message ||
            'Unable to add free gift'
          );

        }


        /*
         * Reload so cart drawer,
         * totals and selected gift
         * are rendered correctly.
         */

        window.location.reload();


      } catch (error) {

        console.error(
          'Free gift promotion error:',
          error
        );


        button.disabled = false;
        button.textContent = originalText;


        alert(
          error.message ||
          'Sorry, your free gift could not be added. Please try again.'
        );

      }

    }
  );



  /*
   * CHECK FOR INVALID GIFTS
   * WHEN PAGE LOADS
   */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      removeInvalidFreeGifts
    );

  } else {

    removeInvalidFreeGifts();

  }
/*
 * WATCH CART DRAWER FOR AJAX CHANGES
 *
 * When an item is removed/changed in the cart drawer,
 * run free-gift validation again.
 */

let freeGiftValidationTimer;

const freeGiftCartObserver = new MutationObserver(function () {

  clearTimeout(freeGiftValidationTimer);

  freeGiftValidationTimer = setTimeout(function () {

    removeInvalidFreeGifts();

  }, 300);

});


freeGiftCartObserver.observe(document.body, {
  childList: true,
  subtree: true
});

})();